import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Component,
  inject,
  ViewChild,
  OnInit,
  DestroyRef,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';

import {
  BusinessService,
  UserCreateModalComponent,
  User,
  UserService,
} from '../../../index';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ModalAlertComponent, ModalEmailComponent } from '@shared/components';
import { ToastAlertService } from '@core/services';
import { ConfigService } from '../../../services/config.service';
import { Business } from '../../../models/business.model';
import { Cookies } from 'typescript-cookie';
import { TypeUserComponent } from '@shared/components/type-user/type-user.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SearchFieldComponent } from '@shared/components/search-field/search-field.component';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf, NgFor, UpperCasePipe, AsyncPipe } from '@angular/common';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable, map, startWith } from 'rxjs';
import { MatInputModule } from '@angular/material/input';
import { ModalAlertDesactivarComponent } from '@shared/components/modal-alert-desactivar';
import { ModalAlertActivarComponent } from '@shared/components/modal-alert-activar';

@Component({
  templateUrl: './worker-page.component.html',
  styles: [],
  standalone: true,
  imports: [
    ToolbarComponent,
    NgIf,
    MatFormFieldModule,
    MatSelectModule,
    NgFor,
    MatOptionModule,
    SearchFieldComponent,
    ButtonComponent,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatPaginatorModule,
    UpperCasePipe,
    MatAutocompleteModule,
    AsyncPipe,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
})
export class WorkerPageComponent implements OnInit {
  paginatorIntl: MatPaginatorIntl = new MatPaginatorIntl();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  private destroyRef = inject(DestroyRef);

  displayedColumns: string[] = [
    'user_name',
    'first_name',
    'last_name',
    'user_code',
    'email',
    'email2',
    'phone',
    'address',
    'building_name',
    'workerGroupName',
    'role_name',
    'actions',
  ];
  dataSource: MatTableDataSource<User>;
  fielInput!: string;
  workerCodes: string[] = [];
  // SERVICES
  private dialog = inject(MatDialog);
  private userService = inject(UserService);
  private alertService = inject(ToastAlertService);
  private businessService = inject(BusinessService);
  public isSysAdmin = inject(ConfigService).isSysAdmin;

  //DATA
  public bussines: Business[] = [];
  public selectedBussines = -1;
  private businessId: number | null | undefined;
  myControl = new FormControl('');
  constructor() {
    this.paginatorIntl = new MatPaginatorIntl();
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit(): void {
    this.role();
    this.loadworkers();
    this.getBusiness();
  }
  getRowStyles(element: any) {
    if (element == 'BAJA') {
      return { 'background-color': '#B0BEC5' }; // Gris para estado 1
    } else {
      return {}; // No se aplica ningún estilo adicional
    }
  }
  loadworkers() {
    const business = Cookies.get('bussinesId');
    const idROle = Cookies.get('role');
    if (idROle === 'ADMINISTRADOR') {
      this.getBusiness();
      if (business != null) {
        this.businessId = parseInt(business.toString());
        this.selectedBussines = this.businessId;
        this.sortByBussines();
      } else {
        if (this.selectedBussines !== -1) {
          this.sortByBussines();
        } else {
          this.sortByBussinesSysadmin();
        }

        this.selectedBussines = -1;
        this.businessId = null;
      }
    }
  }

  isRole: boolean = false;
  roleName = signal<string>('');
  role() {
    const role = Cookies.get('role');
    this.roleName.set(Cookies.get('role')!.toString());
    if (role && role === 'ADMINISTRADOR') {
      this.isRole = true;
    } else {
      this.isRole = false;
    }
  }

  filteredOptions: Observable<Business[]> = new Observable<Business[]>(
    observer => {
      observer.next([]);
    }
  );
  public selectedBussinesName = '';

  onOptionSelected(value: number, name: string) {
    this.selectedBussines = value;
    this.selectedBussinesName = name;
    this.myControl.setValue(this.selectedBussinesName);
    this.applyFilter();
  }

  applyFilter() {
    const value = this.myControl.value;
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(value),
      map(value => this._filter(value))
    );
  }
  private _filter(value: string | null): Business[] {
    const filterValue = (value || '').toLowerCase();
    // Actualiza el valor de búsqueda anterior
    if (!filterValue) {
      return this.bussines;
    }
    return this.bussines.filter(
      bussines =>
        this.removeDiacritics(bussines.name.toLowerCase()).includes(
          this.removeDiacritics(filterValue)
        ) ||
        (bussines.idBusiness !== undefined &&
          bussines.idBusiness.toString().includes(filterValue))
    );
  }

  removeDiacritics(text: string): string {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  ValidBusiness_id(): boolean {
    return this.businessId === null;
  }

  sortByBussinesSysadmin() {
    this.userService
      .getUsersByBussines()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((request: any) => {
        if (request.code === 10000) {
          this.dataSource = new MatTableDataSource(request.reply);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.workerCodes = [];
          request.reply.forEach((item: { user_code: string }) => {
            this.workerCodes.push(item.user_code);
          });
        } else {
          this.dataSource = new MatTableDataSource();
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      });
  }
  sortByBussines() {
    this.userService
      .getUsersByBussines(this.selectedBussines)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((request: any) => {
        if (request.code === 10000) {
          this.dataSource = new MatTableDataSource(request.reply);
          this.configureSortingAccessor();
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.workerCodes = [];
          request.reply.forEach((item: { user_code: string }) => {
            this.workerCodes.push(item.user_code);
          });
        } else {
          this.dataSource = new MatTableDataSource();
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      });
  }
  configureSortingAccessor() {
    this.dataSource.sort = this.sort;
    // Configurar sortingDataAccessor aquí
    this.dataSource.sortingDataAccessor = (
      item: any,
      property: string
    ): string | number => {
      const value = item[property as keyof any];

      if (typeof value === 'string') {
        return value.toLowerCase();
      } else if (typeof value === 'number') {
        return value;
      }

      return '';
    };
  }

  public getUsers() {
    this.userService
      .getUsersByBussines()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((request: any) => {
        if (request.code === 10000) {
          this.dataSource = new MatTableDataSource<User>(request.reply);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      });
  }

  private getBusiness() {
    this.businessService
      .getBusiness()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000) {
            if (this.roleName() !== 'ACCESOS') {
              this.bussines = request.reply;

              this.filteredOptions = this.myControl.valueChanges.pipe(
                startWith(''),
                map(value => this._filter(value))
              );
              this.dataSource.paginator = this.paginator;
              this.dataSource.sort = this.sort;
              this.spanish();
            }
          }
        },
      });
  }

  modalAction(user?: User): void {
    let width: string;

    if (window.innerWidth <= 768) {
      width = '90%';
    } else {
      width = '60%';
    }

    if (user?.worker_id != null) {
      const dialogActionDetail = this.dialog.open(UserCreateModalComponent, {
        width: width,
        data: { type: 'Editar', data: user, codes: this.workerCodes },
        disableClose: true,
      });
      dialogActionDetail
        .beforeClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(response => {
          if (response) {
            const business = Cookies.get('bussinesId');
            if (business != null) {
              this.sortByBussines();
            } else {
              if (this.selectedBussines !== -1) {
                this.sortByBussines();
              } else {
                this.sortByBussinesSysadmin();
              }
            }
          }
        });
    } else {
      const dialogActionDetail = this.dialog.open(TypeUserComponent, {
        width: width,
        disableClose: true,
        data: { codes: this.workerCodes, role: this.roleName() },
      });
      dialogActionDetail
        .beforeClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(response => {
          if (response) {
            this.sortByBussines();
          }
        });
    }
  }

  modalBaja(user: User) {
    const dialogDelete = this.dialog.open(ModalAlertDesactivarComponent, {
      data: user.first_name + ' ' + user?.last_name,
    });
    dialogDelete
      .beforeClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(request => {
        if (request) {
          this.userService
            .deleteUser(user.worker_id as number)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
              next: response => {
                if (response.code === 10000) {
                  this.alertService.sucess('Usuario suspendido');
                  this.sortByBussines();
                } else {
                  this.alertService.error(response.detail);
                }
              },
            });
        } else {
          console.log('Cancelada la eliminacion');
        }
      });
  }

  modalAlta(user: User) {
    const dialogDelete = this.dialog.open(ModalAlertActivarComponent, {
      data: user.first_name + ' ' + user?.last_name,
    });
    dialogDelete
      .beforeClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(request => {
        if (request) {
          this.userService
            .deleteUser(user.worker_id as number)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
              next: response => {
                if (response.code === 10000) {
                  this.alertService.sucess('Usuario activado');
                  this.sortByBussines();
                } else {
                  this.alertService.error(response.detail);
                }
              },
            });
        } else {
          console.log('Cancelada la eliminacion');
        }
      });
  }

  spanish() {
    if (this.paginator) {
      this.paginator._intl.itemsPerPageLabel = 'Registros por página';
      this.paginator._intl.nextPageLabel = 'Página siguiente ';
      this.paginator._intl.previousPageLabel = 'Página anterior';
      this.paginator._intl.firstPageLabel = 'Primera página';
      this.paginator._intl.lastPageLabel = 'Última página';
      // Configuración del texto de la última página
      this.paginator._intl.getRangeLabel = (
        page: number,
        pageSize: number,
        length: number
      ) => {
        if (length === 0 || pageSize === 0) {
          return `0 de ${length}`;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex =
          startIndex < length
            ? Math.min(startIndex + pageSize, length)
            : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} de ${length}`;
      };
    }
  }
}
